module.exports = __webpack_public_path__ + "static/media/fly0286.b6a6889e.webp";